<template>
  <dt-illustration name="dialpad-logo" class="dp-topbar-logo" />
</template>

<style lang="less" scoped>
.dp-topbar-logo {
  width: auto;
  height: calc(var(--dt-size-600) - var(--dt-size-300));
}
</style>
<script setup>
import { DtIllustration } from '@dialpad/dialtone/vue3';
</script>
